import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import Optin from "../views/Optin.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {    
    path: "/optin/:id",
    name: "Optin",
    props: true,
    component: Optin
  }
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

export default router;
